import { render, staticRenderFns } from "./ReadSummary.vue?vue&type=template&id=047f7d22&"
import script from "./ReadSummary.vue?vue&type=script&lang=js&"
export * from "./ReadSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports